export default {
  ra: {
    action: {
      add: "Engadir",
      add_filter: "Engadir filtro",
      back: "Ir atrás",
      bulk_actions:
        "1 ítem seleccionado |||| %{smart_count} ítems selecccionados",
      cancel: "Cancelar",
      clear_input_value: "Limpar valor",
      clone: "Clonar",
      close: "Pechar",
      close_menu: "Pechar menú",
      confirm: "Confirmar",
      create: "Crear",
      delete: "Eliminar",
      edit: "Editar",
      expand: "Expandir",
      export: "Exportar",
      list: "Listar",
      open_menu: "Abrir menú",
      refresh: "Refrescar",
      remove: "Borrar",
      remove_filter: "Borrar filtro",
      save: "Gardar",
      search: "Buscar",
      show: "Amosar",
      sort: "Ordear",
      undo: "Desfacer",
    },
    auth: {
      auth_check_error: "Por favor inicie sesión para continuar",
      logout: "Pechar Sesión",
      password: "Contrasinal",
      sign_in: "Acceder",
      sign_in_error: "A autenticación fallou, por favor, vólveo intentar",
      user_menu: "Perfil",
      username: "Usuario",
    },
    boolean: {
      true: "Sí",
      false: "Non",
      null: "",
    },
    input: {
      file: {
        upload_several:
          "Arrastra algúns arquivos para subir ou fai clic para seleccionalos.",
        upload_single:
          "Arrastra un arquivo para subir ou fai clic para seleccionalo.",
      },
      image: {
        upload_several:
          "Arrastra algunas imaxes para subir ou fai clic para seleccionalas.",
        upload_single:
          "Arrastra alguna imaxe para subir ou fai clic para seleccionala.",
      },
      references: {
        all_missing: "Non se poden encontrar datos de referencias.",
        many_missing:
          "Polo menos unha das referencias asociadas parece non estar dispoñible.",
        single_missing: "A referencia asociada non parece estar dispoñible.",
      },
      password: {
        toggle_visible: "Ocultar contrasinal",
        toggle_hidden: "Amosar contrasinal",
      },
    },
    message: {
      about: "Sobre",
      are_you_sure: "Estás seguro?",
      bulk_delete_content:
        "Seguro que queres eliminar este %{name}? |||| Seguro que quere eliminar estos %{smart_count} ítems?",
      bulk_delete_title:
        "Eliminar %{name} |||| Eliminar %{smart_count} %{name} ítems",
      delete_content: "Seguro que queres eliminar este ítem?",
      delete_title: "Eliminar %{name} #%{id}",
      details: "Detalles",
      error:
        "Produciuse un erro no cliente e a túa solicitude non se puido completar",
      invalid_form:
        "O formulario non é válido. Por favor, verifica se hai erros",
      loading: "A páxina estase cargando, agarda un momento por favor",
      no: "Non",
      not_found:
        "Ou ben escribistes unha URL incorrecta ou seguistes un enlace incorrecto.",
      yes: "Si",
      unsaved_changes:
        "Algúns dos teus cambios non se gardaron. Está seguro que quere ignorarlos?",
    },
    navigation: {
      next: "Seguinte",
      no_more_results:
        "O número de página %{page} está fóra dos límites. Proba a páxina anterior.",
      no_results: "Non se atoparon resultados",
      page_out_from_begin: "Non pode ir antes da páxina 1",
      page_out_from_end: "Non pode ir despóis da última páxina",
      page_out_of_boundaries: "Número de páxina %{page} fóra dos límites",
      page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      page_rows_per_page: "Ringleiras por páxina:",
      prev: "Anterior",
    },
    notification: {
      bad_item: "Elemento incorrecto",
      canceled: "Acción cancelada",
      created: "Elemento creado",
      data_provider_error:
        "Error do provedor de datos. Consulta a consola para máis detalles.",
      deleted: "Elemento borrado |||| %{smart_count} elementos borrados.",
      http_error: "Erro de comunicación co servidor",
      item_doesnt_exist: "O elemento non existe",
      logged_out: "A túa sesión finalizou, volva a conectarse.",
      updated:
        "Elemento actualizado |||| %{smart_count} elementos actualizados",
      i18n_error:
        "Non se puideron cargar as traduccións para o idioma especificado",
    },
    page: {
      create: "Crear %{name}",
      dashboard: "Taboleiro",
      edit: "%{name} #%{id}",
      empty: "Sen %{name} aínda.",
      error: "Algo saíu mal",
      invite: "Queres agregar unha?",
      list: "Lista de %{name}",
      loading: "Cargando",
      not_found: "Non se atopou",
      show: "%{name} #%{id}",
    },
    validation: {
      email: "Debe ser un correo electrónico válido",
      maxLength: "Debe conter %{max} caracteres ou menos",
      maxValue: "Debe ser %{max} ou menos",
      minLength: "Debe conter %{min} caracteres polo menos",
      minValue: "Debe ser polo menos %{min}",
      number: "Debe ser un número",
      oneOf: "Debe ser un de: %{options}",
      regex: "Debe coincidir cun formato específico (regexp): %{pattern}",
      required: "Requirido",
    },
  },
};
